"use client"

import { toImageSrc } from "@/lib/utils"
import type { CategoryExpressItemProps } from "@/types/types"
import Image from "next/image"
import Link from "next/link"
import "./categoryExpress.css"

export const CategoryExpressItem = ({ item, className = "" }: CategoryExpressItemProps) => {
  const imageUrl = toImageSrc(item.image)
  const isViewAll = item.isViewAll || false
  const hasLink = item.link && item.link.trim()

  if (isViewAll) {
    const content = (
      <div
        className={`category-express-item view-all flex flex-col items-center justify-center rounded-lg cursor-pointer w-full h-[150px] sm:w-full sm:h-[174px] bg-[#157e40] ${className}`}
      >
        <p className="text-center text-xl font-semibold text-white leading-[1.9375rem]">{item.name}</p>
      </div>
    )

    if (hasLink) {
      return (
        <Link href={item.link} target="_blank" rel="noopener noreferrer" className="w-full">
          {content}
        </Link>
      )
    }
    return content
  }

  const content = (
    <div
      className={`category-express-item flex flex-col gap-[1.3125rem] rounded-lg cursor-pointer w-full h-[150px] sm:max-w-[310px] sm:max-h-[174px] sm:w-full sm:h-[174px] sm:p-2 bg-[#eaf8f4] ${className}`}
    >
      <p className="sm:text-left text-center text-sm sm:text-base font-semibold text-[#333333] px-3 sm:px-8 pt-[1.8125rem] sm:pt-[1.375rem] leading-[1.55rem]">
        {item.name}
      </p>
      <div className="flex items-center justify-center sm:justify-end sm:pr-8 sm:pt-1">
        <div className="w-[50px] h-[50px] sm:w-[68px] sm:h-[68px]">
          <Image src={imageUrl} alt={item.name} width={68} height={68} className="object-contain w-full h-full" />
        </div>
      </div>
    </div>
  )

  if (hasLink) {
    return (
      <Link href={item.link} target="_blank" rel="noopener noreferrer" className="w-full">
        {content}
      </Link>
    )
  }
  return content
}
